<template>
  <view-container>
    <view-title title="Reset Password" />

    <form @submit.prevent="handleSubmit">
      <div class="mb-2">
        <label for="newPassword">New Password</label>
        <input type="password" required="required" name="newPassword" class="form-control" v-model="newPassword" :disabled="isLoading">
      </div>

      <div class="mb-2">
        <label for="newPasswordConfirm">Confirm New Password</label>
        <input type="password" required="required" name="newPasswordConfirm" class="form-control" v-model="newPasswordConfirm" :disabled="isLoading">
      </div>

      <form-error-list v-bind:errors="errors"/>

      <div>
        <button type="submit" class="btn btn-success" :disabled="isLoading">Change Password</button>
        <router-link to="/account/settings" tag="button" class="btn btn-danger float-end">Cancel</router-link>
      </div>
    </form>

    <loading-spinner :loading="isLoading"/>
  </view-container>
</template>

<script>
import LoadingSpinnerVue from '../components/LoadingSpinner'
import ViewContainer from '../components/ViewContainer'
import router from '../../router'
import ViewTitle from '../components/ViewTitle'
import FormErrorList from '../components/FormErrorList'
import userService from '../../services/api/user'

export default {
  components: {
    'loading-spinner': LoadingSpinnerVue,
    'view-container': ViewContainer,
    'view-title': ViewTitle,
    'form-error-list': FormErrorList
  },
  data () {
    return {
      isLoading: false,
      errors: [],
      token: null,
      newPassword: null,
      newPasswordConfirm: null
    }
  },
  mounted () {
    this.token = this.$route.query.token
  },
  methods: {
    async handleSubmit (e) {
      this.errors = []

      if (!this.newPassword) {
        this.errors.push('New password required.')
      }

      if (!this.newPasswordConfirm) {
        this.errors.push('New password confirmation required.')
      }

      if (this.newPassword !== this.newPasswordConfirm) {
        this.errors.push('Passwords must match.')
      }

      e.preventDefault()

      if (this.errors.length) return

      try {
        this.isLoading = true

        let response = await userService.resetPassword(this.token, this.newPassword)

        if (response.status === 200) {
          this.$toasted.show(`Your password has been reset.`, { type: 'success' })
          router.push({ name: 'home' })
        } else {
          this.$toasted.show(`There was a problem resetting your password, please try again.`, { type: 'error' })
        }
      } catch (err) {
        console.log(err)
        this.errors = err.response.data.errors || []
      }

      this.isLoading = false
    }
  }
}
</script>

<style scoped>
</style>
